import axios from 'axios';

export const fetchChatbotQuery = (serviceUrl, queryParams) =>
  axios
    .get(serviceUrl, {
      params: {
        api: 1,
        type: 'json',
        isCookieEnabled: 1,
        CheckAdditionalCondition: true,
        nt: 1,
        timestamp: Date.now(),
        ...queryParams,
      },
      withCredentials: true,
    })
    .then((res) => res.data);
